import {
  type OfferV11,
  type PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { type TENANT } from '../../../tenant'
import { offerAccessorIsLastThirtyDaysPriceEnabled } from '../offerAccessor/offerAccessorIsLastThirtyDaysPriceEnabled'
import { priceAccessorGetThirtyDaysDiscountFromOffer } from '../priceAccessor/priceAccessorGetThirtyDaysDiscountFromOffer'
import {
  priceAccessorGetThirtyDaysPriceTrend,
  PRODUCT_THIRTY_DAYS_PRICE_TREND,
} from '../priceAccessor/priceAccessorGetThirtyDaysPriceTrend'

export const productAccessorGetDiscountFromOffer = ({
  currentPrescriptionType,
  offer,
  tenant,
}: {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  offer: OfferV11
  tenant: TENANT
}): number => {
  const discount =
    offer.offerPrice?.additionalInformation?.discount?.percentage ?? 0

  if (!offerAccessorIsLastThirtyDaysPriceEnabled(offer, tenant)) {
    return discount
  }

  const discountThirtyDays = priceAccessorGetThirtyDaysDiscountFromOffer(offer)
  const thirtyDaysPriceTrend = priceAccessorGetThirtyDaysPriceTrend(
    offer,
    currentPrescriptionType,
  )
  const isPriceTrendDown =
    thirtyDaysPriceTrend === PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_DOWN

  const usedDiscount = isPriceTrendDown ? discountThirtyDays : 0

  return usedDiscount
}
